import OperationalTargetsListView from './OperationalTargetsListView';

import "./OperationalTargetsListView.scss";

export * from './OperationalTargetsListView.types';

export { OperationalTargetsListView };

